import React from "react";
import { Card, Spin, Alert } from "antd";
import { observer } from "mobx-react-lite";
import { WidgetState } from "../stores/WorkbenchStore";

export interface WorkbenchWidgetCardProps {
    title: string;
    size?: "default" | "small";
    widgetState: WidgetState;
    children: React.ReactNode;
    className?: string;
}

const WorkbenchWidgetCard: React.FC<WorkbenchWidgetCardProps> = ({
    title,
    size = "small",
    widgetState,
    children,
    className,
}) => {
    const renderContent = () => {
        if (widgetState.isLoading) {
            return (
                <div className="widget-loading">
                    <Spin size="small" />
                    <span style={{ marginLeft: 8 }}>Loading...</span>
                </div>
            );
        }

        if (widgetState.error) {
            return (
                <Alert
                    message="Error"
                    description={widgetState.error}
                    type="error"
                    showIcon
                />
            );
        }

        if (!widgetState.hasData && widgetState.lastQuery) {
            return (
                <div className="widget-no-data">
                    <span>
                        No data found for &quot;{widgetState.lastQuery}&quot;
                    </span>
                </div>
            );
        }

        if (!widgetState.lastQuery) {
            return (
                <div className="widget-placeholder">
                    <span>Search to load content</span>
                </div>
            );
        }

        return children;
    };

    return (
        <Card
            title={title}
            size={size}
            className={`workbench-widget-card ${className || ""}`}
        >
            {renderContent()}
        </Card>
    );
};

export default observer(WorkbenchWidgetCard);
